import { CSSProperties, forwardRef } from 'react';
import cn from 'clsx';
import NumberFormat, { NumberFormatProps } from 'react-number-format';

import { Color, Colors } from '../Colors';

import './InputText.css';

export type InputTextProps = NumberFormatProps & {
  borderColor?: Color | string;
  shadowColor?: Color | string;
  border?: boolean;
  shadow?: boolean;
};

const InputText = forwardRef<NumberFormat, NumberFormatProps>(
  (
    {
      borderColor = Colors.magenta,
      shadowColor = Colors.blue,
      border = true,
      shadow = true,
      onChange,
      neon = '',
      className,
      disabled,
      children,
      value,
      ...props
    },
    ref
  ) => {
    // eslint-disable-next-line no-param-reassign
    if (Colors[borderColor]) borderColor = Colors[borderColor];
    // eslint-disable-next-line no-param-reassign
    if (Colors[shadowColor]) shadowColor = Colors[shadowColor];

    const _onChange = (e: any) => {
      // console.log(e?.currentTarget?.value);
      if (onChange) onChange(e?.currentTarget?.value);
    };

    const rootCn = neon
      ? cn(
          ' bg-transparent py-3 px-2 w-full font-display text-sm outline-none',
          'placeholder-opacity-80 focus:placeholder-opacity-40 text-white text-opacity-100 focus:text-opacity-80 text-base',
          {
            'border-gray-dark': border,
            'bg-gray-50 cursor-not-allowed': disabled,
            'placeholder-white': !disabled,
          },
          className
        )
      : cn(
          'input-text  bg-white py-3 px-2 w-full font-display text-sm outline-none',
          'placeholder-opacity-80 focus:placeholder-opacity-40 text-gray-darkest text-opacity-100 focus:text-opacity-80 text-base',
          {
            'border-gray-dark': border,
            'bg-gray-50 cursor-not-allowed': disabled,
            'placeholder-purple': !disabled,
          },
          className
        );

    const rootStyle: CSSProperties = {};
    if (!disabled) {
      if (border) rootStyle.borderColor = borderColor;
      if (shadow) rootStyle.boxShadow = `4px 4px 0px 0px ${shadowColor}`;
    } else {
      if (shadow) rootStyle.boxShadow = `4px 4px 0px 0px ${Colors.lightGray}`;
    }
    return (
      <NumberFormat
        className={rootCn}
        style={{ ...rootStyle, borderBottom: '2px solid ' + neon }}
        ref={ref}
        disabled={disabled}
        value={value}
        onChange={_onChange}
        {...props}
      />
    );
  }
);

InputText.displayName = 'InputText';

export default InputText;
